const CHECKLIST = 'Checklist';
const RFD = 'Reason for Default';
const EDITABLE_FIELDS = ['Reason for Default', 'Occupancy Type'];
const RFD_ERROR = "Couldn't fetch RFD Data.Service down";
const COLLATERAL_ERROR = "Couldn't fetch Collateral data. Service down";
const COLLATERAL_SUCCESS_MSG = 'Successfully saved in TKAMS';
const NO_DATA = 'No data available';
const EXCEPTION = 'Exception while saving Request';
const LOAN_LIEN_ERROR = "Couldn't add loan balance. Please try after sometime";
const SAVE_ERROR = 'Error while saving Data.Please try after sometime';
const RFD_DIALOG_MSG = 'Are you sure you want to discard the unsaved changes?';
const RFD_TITLE = 'Reason for Default (RFD)';
const RFD_SAVE_INFO = 'Clicking on the Save Button will Add the RFD information to the Reason(s) History';

module.exports = {
  CHECKLIST,
  RFD,
  EDITABLE_FIELDS,
  RFD_ERROR,
  COLLATERAL_ERROR,
  COLLATERAL_SUCCESS_MSG,
  NO_DATA,
  EXCEPTION,
  LOAN_LIEN_ERROR,
  SAVE_ERROR,
  RFD_DIALOG_MSG,
  RFD_TITLE,
  RFD_SAVE_INFO,
};
